import { render } from "./editor-text-disabled.vue?vue&type=template&id=6c7f2290"
import script from "./editor-text-disabled.vue?vue&type=script&lang=js"
export * from "./editor-text-disabled.vue?vue&type=script&lang=js"

import "./editor-text-disabled.vue?vue&type=style&index=0&id=6c7f2290&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__